import { BaseModel, Resource, Form, Entry, EntryTypes } from '@ngx-resource-toolkit/core';
import { environment } from '../../../../../environments/environment';
import { LeaResource } from '../../../../shared/resource/lea.resource';
import { disciplineFetchOptions, cursusFetchOptions } from '../../../../shared/resource/select-options';
import { TABLE } from '../../../../app.constantes';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/discipline',
            methods: LeaResource.methods
        }
    }
})
@Form({
    'edit': {},
    'create': {},
    'table': {},
})
export class DisciplineModel extends BaseModel {

	// const TYPE_FM=1;
	// const TYPE_FI=2;
	// const TYPE_PC=3;
	// const TYPE_DANSE=4;

    @Entry({
        base: {
            hidden: true,
        },
        'table': {},
        'create': {},
        'edit': {},
    })
    _explicitType: string = 'Discipline';

    @Entry({
        'table': {
            label: 'N°',
            flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.ID,
        },
        'edit': {
            label: 'N°',
            type: EntryTypes.STATIC,
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        }
    })
    id: string;

    @Entry({
        base: {
            label: 'Libellé',
            type: EntryTypes.TEXT,
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
        'create': {},
        'edit': {},
        'table': {
            flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
    })
    libelle: string;

    @Entry({
        base: {
            label: 'Type de discipline',
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
        'create': {
            type: EntryTypes.SELECT,
            /*options: [{
                label: 'TODO',
                value: '1'
            }],*/
        },
        'edit': {
            type: EntryTypes.SELECT,
        },
        'table': {
            label: 'Type',
            flexGrow: 1,
            hidden: true,
            // transform: (value) => {
            //     switch(value) {
            //         case
            //     }
            // }
        },
    })
    typeDiscipline: string;
    @Entry({
        base: {
            label: 'Type de discipline',
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
            },
            hidden: true,
        },
        'table': {
            label: 'Type',
            flexGrow: 1,
            type: EntryTypes.STATIC,
            hidden: false,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
            // transform: (value) => {
            //     switch(value) {
            //         case
            //     }
            // }
        },
    })
    typeDisciplineLibelle: string;

    @Entry({
        base: {
            label: 'Cursus',
            type: EntryTypes.SELECT,
            // fetchOptions: cursusFetchOptions,
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
        'create': {},
        'edit': {},
        'table': {
            flexGrow: 1,
            hidden: true,
        },
    })
    cursusId: string;
    @Entry({
        base: {
            label: 'Cursus',
            type: EntryTypes.STATIC,
            hidden: true,
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
        'table': {
            flexGrow: 1,
            hidden: false,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
    })
    cursusLibelle: string;

    @Entry({
        base: {
            // label: 'Activé',
            type: EntryTypes.CHECKBOX,
            options: [{
                label: 'Activé',
                value: true
            }],
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
        'create': {},
        'edit': {},
        'table': {
            label: 'Activé',
            flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.BOOLEAN,
            transform: (value) => value ? 'X' : '',
        },
    })
    isActivated: boolean;

    constructor(data?) {
        super();
        if (!data) data = {};

        Object.assign(this, data);
    }
}



@Form({
    'create': {},
    'table': {},
})

export class DisciplineRelationModel extends BaseModel {
    @Entry({
        'create': {
            hidden: true,
        }
    })
    id: number; // id de la relation

    @Entry({
        'create': {
            type: EntryTypes.SELECT,
            css: {group: 'col-xs-12'},
            fetchOptions: disciplineFetchOptions,
        }
    })
    disciplineId: number;

    @Entry({
        'create': {
        },
        'table' : {
            transform: (value) => value.libelle,
            label: 'libellé',
        }
    })
    discipline: DisciplineModel;

    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }
        this.id = data.id;
        this.disciplineId = data.disciplineId;
        this.discipline = new DisciplineModel(data.discipline);
    }
}




// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/parametrage/listes/disciplines/models/discipline.model.ts